import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from 'yankees-react-utils';
import usePlayerSelector from '../../../utils/usePlayerSelector';
import { useOktaQuery, KeyTakeaway, Team } from '../../../data';
import KeyTakeawayComponent from '../../../components/KeyTakeaway';
import MatchupPitcherSelector from '../Player/MatchupPitcherSelector';

const TeamKeyTakeaways = ({ match: { params: { teamId: vsTeamId } }, playerTeamStartingPitchers }) => {
    const { t: translate } = useTranslation();
    const playerUser = usePlayerSelector();
    const [selectedPitcher, setSelectedPitcher] = useState(!playerUser.IsPitcher && playerTeamStartingPitchers?.length
        ? { ...playerTeamStartingPitchers[0], name: playerTeamStartingPitchers[0].FullName, value: playerTeamStartingPitchers[0].PlayerID }
        : {});
    const { Throws: throws } = (!playerUser.IsPitcher ? (selectedPitcher || {}) : playerUser);

    const { data: keyTakeaways, isFetching: loadingKeyTakeaways } = useOktaQuery(
        ['KeyTakeaways', { teamid: vsTeamId }],
        (t) => KeyTakeaway.getByTeam(t, vsTeamId),
    );

    const { data: lineup, isFetching: loadingLineup } = useOktaQuery(['lineup', vsTeamId], (t) => Team.lineup(t, vsTeamId, true));

    if (loadingKeyTakeaways || loadingLineup) return <LoadingSpinner />;
    return (
        <>
            {!playerUser.IsPitcher && (
                <div className="d-flex align-items-center justify-content-end mb-3">
                    <b className="me-1">{translate('common.select-a-pitcher')}:</b>
                    <MatchupPitcherSelector
                        onSelect={setSelectedPitcher}
                    />
                </div>
            )}
            {(playerUser.IsPitcher || selectedPitcher) && keyTakeaways
                .filter((kt) => kt.ShowToHand === null || kt.ShowToHand === throws)
                .sort((a, b) => {
                    const aLineup = lineup?.find((l) => l.PlayerID === a.PlayerID);
                    const bLineup = lineup?.find((l) => l.PlayerID === b.PlayerID);
                    return (aLineup?.SortOrder ?? 99) - (bLineup?.SortOrder ?? 99);
                })
                .map((kt) => (
                    <KeyTakeawayComponent key={kt.TakeawayID} takeaway={kt} showPlayerName isOpen={false} />
                ))}
        </>
    );
};

TeamKeyTakeaways.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            teamId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        }).isRequired,
    }).isRequired,
    playerTeamStartingPitchers: PropTypes.arrayOf(PropTypes.shape({
        PlayerID: PropTypes.number.isRequired,
        FullName: PropTypes.string.isRequired,
    })),
};
TeamKeyTakeaways.defaultProps = {
    playerTeamStartingPitchers: [],
};

export default TeamKeyTakeaways;
